import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import { Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { setError } from 'slices/departmentsSlice';
import { fetchFacilities } from 'slices/facilitiesSlice';
import { updateDepartment } from 'slices/departmentsSlice';
import { addDepartment } from 'slices/departmentsSlice';
import { fetchDepartments } from 'slices/departmentsSlice';
import { departmentsSelector } from 'slices/departmentsSlice';

const apiService = new Api();
const AddDepartmentForm = ({ item, handleClose, callback, show, statusPerm, userId }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
  const { error, loader } = useSelector(departmentsSelector);
  const [buttonLoader, setButtonLoader] = useState(false);
  
  useEffect(() => {
    setValue('facility_id', item?.facility_id || '')
    setValue('department_name', item?.department_name || '')
    setValue('facility_billing_code', item?.facility_billing_code || '');
    setValue('department_billing_code', item?.department_billing_code || '');
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    dispatch(setError({}))
  }, [item])

  const ResetField = () => {
    setValue('department_name', '')
    setValue('facility_billing_code', '');
    setValue('department_billing_code', '');
    setValue('status', 1)
  }

  useEffect(() => {
    !show && ResetField();
    return () => ResetField()
  }, [show])



  const [filterFacilities, setfilterFacilities] = useState({
    label: "",
    value: ""
  })

  useEffect(() => {
    if (item?.facility?.abbreviation && item?.facility?.id) {
      setfilterFacilities({
        label: item?.facility?.abbreviation || "",
        value: item?.facility?.id || ""
      })
    } else {
      setfilterFacilities(null)
    }
  }, [item?.facility])

  const filteredFacitiesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchFacilities(page, { user_id: userId, pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.abbreviation,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })      
      handleClose()
      ResetField()
      setButtonLoader(false)
      dispatch(fetchDepartments(1, { user_id: userId }))
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
      setTimeout(() => {
        setButtonLoader(false)
      }, 1000);
    }
  };

  const onSubmit = (data) => {
    setButtonLoader(true);
    const formData = {
      ...data,
      user_id: userId,
    }

    if (item?.id) {
      dispatch(updateDepartment(formData, item?.id, submitCallback, true));
    }
    else
      dispatch(addDepartment(formData, submitCallback, true));

  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row-primary">
        <h2>Facility Name *</h2>
        <div className='w-100'>
          <Controller
            name="facility_id"
            control={control}
            rules={{
              required: "Please select a facility"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={filterFacilities}
                  loadOptions={filteredFacitiesLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    if (obj?.value) {
                      setfilterFacilities(obj)
                      field.onChange(obj.value);
                    }
                    else {
                      setfilterFacilities(null)
                      field.onChange(null);
                    }
                  }}
                  additional={{
                    page: item?.state?.id ? 2 : 1,
                  }}
                />
                {errors?.facility_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.facility_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>
      </div>

      <div className="row-primary">
        <h2>Depatment Name*</h2>

        <Controller
          name="department_name"
          control={control}
          rules={{
            required: "Department name is required"
          }}
          render={({ field }) =>
            <div className="w-100">
              <input className="input-in type_inp" type="text" name='department_name' placeholder='Department name'{...field} />
              {error?.errors?.department_name?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
              {errors?.department_name?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.department_name?.message} />
                </div>
              }
            </div>
          }
        />
      </div>

      <div className="row-primary">
        <h2>Facility Billing Code</h2>
        <Controller
          name="facility_billing_code"
          control={control}
          render={({ field }) =>
            <div className="w-100">
              <input className="input-in type_inp" type="text" name='facility_billing_code' placeholder='Billing code'{...field} />
              {errors?.facility_billing_code?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.facility_billing_code?.message} />
                </div>
              }
            </div>
          }
        />

      </div>

      <div className="row-primary">
        <h2>Department Billing Code</h2>
        <Controller
          name="department_billing_code"
          control={control}
          render={({ field }) =>
            <div className="w-100">
              <input className="input-in type_inp" type="text" name='department_billing_code' placeholder='Billing code'{...field} />
              {errors?.department_billing_code?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.department_billing_code?.message} />
                </div>
              }
            </div>
          }
        />
      </div>

      {statusPerm &&
        <div className="row-primary" style={{ alignItems: "center" }}>
          <h2>Status</h2>
          <Controller name="status" control={control} required
            rules={{
              required: true
            }}
            render={({ field }) => (
              <CustomSwitch labelText={field.value == 1 ? "Active" : "Inactive"} checked={field.value} handleChange={(checked) => field.onChange(checked ? 1 : 0)} />
            )}
          />
        </div>
      }


      <div className="Form-footer">
        <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
        <button type="submit" disabled={buttonLoader ? 'disabled' : ''} className="main_button">

          {buttonLoader ?
            <>
              <Spinner size="sm">
                Loading...
              </Spinner>

              <span>
                {' '}Loading
              </span>
            </>
            :
            <span>
              {item?.id ? "Update" : "Create"}
            </span>
          }
        </button>
      </div>
    </form>
  )
}

const AddDepartment = ({ item, onClose, callback, show, statusPerm, userId }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Department</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddDepartmentForm item={item} handleClose={onClose} show={show} callback={callback} statusPerm={statusPerm} userId={userId} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddDepartment
